import type { FC } from 'react';
import { LinearProgress } from '@mui/material';

const LoadingScreen: FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <div className="top-loading-bar">
      <LinearProgress color="info" />
    </div>
  );
};

export default LoadingScreen;
